/**
 * Vite injects `import.meta.env` at build time. Do not use `new Function` / eval — `import.meta`
 * is only valid in module goal code and throws in the browser when evaluated that way.
 *
 * Jest: `moduleNameMapper` resolves this module to `src/tests/__mocks__/viteMetaEnv.ts`.
 */

export function getViteMetaEnv(): ImportMetaEnv {
  return import.meta.env;
}
